<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                    <el-form-item   prop="name" label="维度名称">
                        <el-input v-model="form.name" maxlength="50" style="width:200px;"></el-input>
                    </el-form-item>
                    <el-form-item prop="name" label="五育类型">
                        <el-select v-model="form.type" placeholder="请选择">
                            <el-option
                                v-for="item in types"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item   prop="orderNum" label="排序号">
                        <el-input v-model="form.orderNum" maxlength="20" type="number" style="width:200px;"></el-input>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http'; 

    export default {
        data(){
            return{
                visible: false,
                form:{
                    id:"",
                    deptId:"",
                    name:"",
                    type:"",
                    orderNum:"",
                },
                rules: {
                    name: [
                        { required: true, message: '请输入名称', trigger: 'blur' }
                    ]
                },
                types:[{
                    value:1,
                    label:'德育'
                },{
                    value:2,
                    label:'智育'
                },{
                    value:3,
                    label:'体育'
                },{
                    value:4,
                    label:'美育'
                },{
                    value:5,
                    label:'劳育'
                }]
            }
        },
        created:function () {
        },
        mounted:function () {
        },
        methods:{
            init(data){
                this.visible=true
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields()
                }
                this.form.id=data.id
                this.form.name=data.name
                this.form.type=data.type
                this.form.orderNum=data.orderNum
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.evaluateTypeUpdateUrl;
                        let data = {
                            id:this.form.id,
                            name:this.form.name,
                            type:this.form.type,
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/UpdateType.vue